<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |    
      <router-link to="/autos">Autos</router-link> | 
      <router-link to="/marcas">Marcas</router-link> |  
      <!-- <router-link to="/temporal">LlenarBDMarcas</router-link> |  -->
      <router-link to="/puestos">Puestos</router-link> | 
      <router-link to="/personas">Personas</router-link> |  
      <router-link to="/about">About</router-link>        
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name:'App',
  components:{

  },
  data(){
    return{

    }
  },

  mounted(){
    this.$store.dispatch('llamarparking');
    this.$store.dispatch('llamarautos');
    this.$store.dispatch('llamarmarcas');
    this.$store.dispatch('llamarpuestos');
    this.$store.dispatch('llamarpersonas');



  }



}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.etiqueta {
    font-size: 30px;  
    color:black;
    font-weight: 100;  
    border: 0;
    background-color:rgb(236, 229, 229);
    width: 300px;

}
.etiquetaLabel {
    font-size: 30px;  
    color:black;
    font-weight: 100;  
    border: 0;
    background-color: rgb(173, 220, 241);
    width: 300px;
    

}
form {
    margin-left: auto;
    margin-right: auto;
    width: 300px;
    
}
//color de variable bootstrap
//$primary: #6cb1f7;
@import '../node_modules/bootstrap/scss/bootstrap.scss'

</style>
